<template>
  <div>
      <br/>
     <div slot="header">
          <h3>
            Alert
          </h3>
        </div>
        <br/>
        <div slot="media">
          <img src="../../../assets/images/NewLocation/listAlert.png" alt="">
        </div>
        
  </div>
</template>

<script>
export default {
    name: 'ListAlert'
}
</script>

<style>

</style>